export default __webpack_public_path__ + "static/media/branch-management-ar.b969f2e7.png";